export const spiltContact = (num) => num.split('-')

export const joinContact = (code, number) => `${code}-${number || ''}`

export const getKeyLabel = (arr) => {
    return arr.map(e => {
        e.value = e.name
        return e
    })
}

export const getThumbor = (dimension = '48x48', quality = 80) => {
    if (process.env.REACT_APP_THUMBOR_URL) return `${process.env.REACT_APP_THUMBOR_URL}/${dimension}/filters:quality(${quality})/`
    else return ''
}